<template>
    <div id="projectList">
        <a-row style="margin: 10px 0">
            <img style="margin:0 4px"  @click="addProTab"class="sbxs" src="../../assets/img/ss-add.png"  width="22" height="22">
            <a-popconfirm
                    :title="$t('pubGicSet.AreyoudeleTask')"
                    :okText="$t('pubGicSet.Yes')"
                    :cancelText="$t('pubGicSet.No')"
                    @confirm="deleteproject"
            >
                <a-tooltip placement="topLeft">
                    <template slot="title">
                        <span>{{ $t('roleGe.Delete') }}</span>
                    </template>
                    <img class="sbxs" src="../../assets/img/ss-delete.png"  width="22" height="22">
                </a-tooltip>
            </a-popconfirm>
        </a-row>
        <vxe-table
                stripe
                highlight-hover-row
                border
                resizable
                size="mini"
                ref="preojectTable"
                class="vxe-table-antd"
                :data="projectDataTab"
                max-height="250"
        >
            <template v-slot:empty>
                <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
            </template>
            <vxe-table-column  type="checkbox" width="60"></vxe-table-column>
            <vxe-table-column field="projectName" :title="$t('roleGe.Project')" show-header-overflow="ellipsis" show-overflow="ellipsis">
                <template v-slot="{ row }">
                    <span style="fontSize: 12px;height: 30px;line-height: 30px;display: block;">
                      {{row.projectCode}}
                    </span>
                </template>
            </vxe-table-column>
        </vxe-table>

        <a-modal :title="$t('roleGe.Add')" v-model="addProjectVis" width="50%">
            <template slot="footer">
                <a-button  type="primary" @click="saveAddproject">{{ $t('publicLang.Save') }}</a-button>
            </template>
            <vxe-table
                    stripe
                    highlight-hover-row
                    border
                    resizable
                    size="mini"
                    ref="AddProjectTable"
                    :data="addProjectTable"
                    max-height="250"
            >
                <template v-slot:empty>
                    <span style="font-size: 12px; color: red;">{{ $t('pubGicSet.NoRecordfound') }}</span>
                </template>
                <vxe-table-column type="checkbox" width="60"></vxe-table-column>
                <vxe-table-column show-header-overflow="ellipsis" show-overflow="ellipsis" field="ProjectName" :title="$t('roleGe.Project')">
                    <template v-slot="{ row }">
                        <span>
                          {{row.projectName}}
                        </span>
                    </template>
                </vxe-table-column>
            </vxe-table>
        </a-modal>
    </div>
</template>
<script>
    import ajax  from "../../api/ajax"
    import api  from "../../api/url"
  export default{
      data(){
          return{
              projectDataTab: [],
              addProjectVis: false,
              addProjectTable: []
          }
      },
      props:{
          ugcUid:{
              type: Number,
              default: function() {
                  return  0;
              }
          }
      },
      created(){
        this.init()
      },
      methods:{
          init(){
              ajax.get(api.USEdDEFUDRPRORJCTFETCH,{'ugcUid': this.ugcUid}).then(res=>{
                  this.projectDataTab = res.data
              })
          },
          addProTab(){
              this.addProjectVis = true
              ajax.get(api.USEdDEFGENERICPROJECTLIST).then(res=>{
                  this.addProjectTable = res.data
              })
          },
          saveAddproject(){
              let selectRecords = this.$refs.AddProjectTable.getCheckboxRecords()
              if(selectRecords.length > 0){
                  let params = {
                          projectCodeList: [],
                          ugcUid: this.ugcUid
                      }
                  selectRecords.forEach(value => {
                      params.projectCodeList.push(value.projectCode);
                  });
                  ajax.post(api.USEdDEFGENERICUDRPROJRCT,params).then(res => {
                      if(res.code == 200){
                          this.addProjectVis = false
                          this.init()
                      }
                  })
              }else{
                  this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                  return
              }
          },
          deleteproject(){
              let selectRecords = this.$refs.preojectTable.getCheckboxRecords()
              if(selectRecords.length > 0){
                  let params = {
                      uids: []
                  }
                  selectRecords.forEach(value => {
                      params.uids.push(value.uid);
                  });
                  ajax.post(api.USEdDEFUDRPRODELETION,params).then(res => {
                      if(res.code == 200){
                          this.init()
                      }
                  })
              }else{
                  this.$customMessage.warning(this.$t('publicLang.PleaseSltAtleast'), 3)
                  return;
              }
          }
      }
  }
</script>